import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import SydLabel, { hookFormErrorAdapter } from '../../../../commonDesign/SydLabel'
import SydTextArea from '../../../../commonDesign/SydTextArea'
import { buildValidationRules, stringifyJSON, parseJSON } from '../utils/fieldUtils'

function JsonFieldEditor ({ field, control, form }) {
  const baseRules = buildValidationRules(field)
  const isRequired = field.validations?.required || field.required

  // Add JSON validation
  const rules = {
    ...baseRules,
    validate: {
      ...(baseRules.validate || {}),
      validJson: (value) => {
        if (!value || value.trim() === '') return true
        const parsed = parseJSON(value)
        return parsed !== null || 'Invalid JSON format.'
      }
    }
  }

  // Transform value for display (object -> string)
  const transformToDisplay = useCallback((value) => {
    if (typeof value === 'string') return value
    return stringifyJSON(value)
  }, [])

  // Transform value for form (string -> keep as string, will parse on submit)
  const transformFromDisplay = useCallback((value) => {
    return value
  }, [])

  return (
    <Controller
      name={field.id}
      control={control}
      rules={rules}
      render={({ field: hookField, fieldState }) => (
        <SydLabel
          label={field.label}
          required={isRequired}
          error={hookFormErrorAdapter(form, fieldState)}
          description={field.description}
        >
          <SydTextArea
            {...hookField}
            value={transformToDisplay(hookField.value)}
            onChange={(e) => hookField.onChange(transformFromDisplay(e.target.value))}
            placeholder={`Enter JSON for ${field.label}`}
            rows={8}
          />
        </SydLabel>
      )}
    />
  )
}

JsonFieldEditor.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    required: PropTypes.bool,
    validations: PropTypes.object,
    validationRules: PropTypes.object
  }).isRequired,
  control: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired
}

export default JsonFieldEditor
